import React, { useState, useEffect } from 'react'
import './Level.css'
//components
import Button from '../../../../components/Button/Button'
import Input from '../../../../components/Input/Input'
//services
import { experienceLevelService } from '../../../../services/ExperienceLevel/index'

const Level = () => {
  const [edit, setEdit] = useState(false)
  const [percentages, setPercentages] = useState([])
  const [beginner, setBeginner] = useState("")
  const [intermediate, setIntermediate] = useState("")
  const [advanced, setAdvanced] = useState("")

  useEffect(() => {
    fetchExperienceLevels();
  }, [])

  const fetchExperienceLevels = async () => {
    try {
      const response = await experienceLevelService.fetchExperiencelevel();
      if(response.status == "success"){
        const beginnerItem = response.data.find(item => item.key === "beginner")
        const intermediateItem = response.data.find(item => item.key === "intermediate")
        const advancedItem = response.data.find(item => item.key === "advanced")

        setBeginner(beginnerItem ? beginnerItem.numeric_value : "")
        setIntermediate(intermediateItem ? intermediateItem.numeric_value : "")
        setAdvanced(advancedItem ? advancedItem.numeric_value : "")
        setPercentages(Array.isArray(response.data) ? response.data : [])
      }
    } catch (error) {
      console.error("Error fetching experience levels:", error);
    }
  }

  const handleEdit = async () => {
     console.log("percentages", percentages)
    try {
      // Update each experience level separately by key
      for (const item of percentages) {
        const experience = {
          key: item.key,
          title_en: item.title_en || "",
          title_es: item.title_es || "",
          numeric_value: item.numeric_value,
          is_active: item.is_active
        }
        console.log("Updating experience level:", experience);
        const result = await experienceLevelService.updateExperienceLevel(item.id, experience);
        if (result) {
          setEdit(!edit);
          fetchExperienceLevels();
        }
      }
    } catch (error) {
      console.error("Error updating experience levels:", error);
    }
  }

  const changeValue = (value, key) => {
    if (key === 'beginner') setBeginner(value)
    if (key === 'intermediate') setIntermediate(value)
    if (key === 'advanced') setAdvanced(value)

    setPercentages((prev) => {
      const list = Array.isArray(prev) ? prev : []
      const exists = list.some((item) => item.key === key)
      if (!exists) return list
      return list.map((item) => (item.key === key ? { ...item, numeric_value: value } : item))
    })
  }

  return (
    <div className="level-config">
      <div className="level-grid">
        <div className="level-field">
          <label>Level beginner*</label>
          <Input
            type="text"
            placeholder="level beginner"
            value={beginner}
            onChange={(e) => changeValue(e.target.value, "beginner")}
            disabled={!edit}
            size="small"
          />
        </div>

        <div className="level-field">
          <label>Level intermediate*</label>
          <Input
            type="text"
            placeholder="level intermediate"
            value={intermediate}
            onChange={(e) => changeValue(e.target.value, "intermediate")}
            disabled={!edit}
            size="small"
          />
        </div>

        <div className="level-field">
          <label>Level advanced*</label>
          <Input
            type="text"
            placeholder="level advanced"
            value={advanced}
            onChange={(e) => changeValue(e.target.value, "advanced")}
            disabled={!edit}
            size="small"
          />
        </div>
      </div>

      <div className="level-actions">
        {edit ? (
          <div className='content_buttons'>
            <Button 
              onClick={() => {
                setEdit(!edit)
                fetchExperienceLevels();
              }} 
              variant="warning" 
              fullWidth={true}
              borderRadius={20}
            >
              Cancel
            </Button>
               <Button 
                onClick={() => handleEdit()} 
                variant="primary" 
                fullWidth={true}
                borderRadius={20}
              >
              Confirm
            </Button>
          </div>
        ) : (
          <Button 
            onClick={() => setEdit(!edit)} 
            variant="primary" 
            borderRadius={20}
          >
            Edit percentages
          </Button>
        )}
      </div>
    </div>
  )
}

export default Level
